module.exports = __webpack_public_path__ + "img/pic5.175ce474.png";